module.exports = __webpack_public_path__ + "img/Faux-Fur.ab38eaa3.jpg";